import { makeStyles } from "@mui/styles";

import {
  ACCENT_COLOR,
  INACTIVE_DOT_COLOR,
  LAYOUT,
} from "./welcomeScreenConstants";

export const useWelcomeScreenStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height:
      "calc(100dvh - var(--safe-area-inset-top) - var(--safe-area-inset-bottom))",
    maxWidth: 480,
    margin: "0 auto",
    overflow: "hidden",
    userSelect: "none",
    WebkitUserSelect: "none",
    touchAction: "pan-y",
    WebkitTouchCallout: "none",
  },
  trackViewport: {
    flex: 1,
    minHeight: 0,
    width: "100%",
    overflow: "hidden",
    position: "relative",
    touchAction: "none",
  },
  track: {
    display: "flex",
    height: "100%",
    willChange: "transform",
  },
  slidePane: {
    flexShrink: 0,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  slideBody: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflowX: "hidden",
    WebkitOverflowScrolling: "touch",
  },
  slideContentWrapper: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  slideContentEnter: {
    animation: "$slideContentEnter 320ms ease both",
  },
  "@keyframes slideContentEnter": {
    from: {
      opacity: 0.72,
    },
    to: {
      opacity: 1,
    },
  },
  "@media (prefers-reduced-motion: reduce)": {
    slideContentEnter: {
      animation: "none",
    },
  },
  slideContent: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
  },
  header: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  logo: {
    width: 120,
    height: "auto",
    display: "block",
  },
  textBlock: {
    flexShrink: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(0.5),
    textAlign: "left",
  },
  title: {
    fontWeight: 700,
    fontSize: "38px",
    lineHeight: 1.15,
    letterSpacing: "-0.02em",
    marginBottom: theme.spacing(0.5),
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.625rem",
    },
  },
  subtitle: {
    fontSize: "0.9375rem",
    lineHeight: 1.4,
    color: "#64748B",
    fontWeight: 400,
  },
  heroWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    minHeight: 0,
    overflow: "hidden",
  },
  heroImage: {
    maxWidth: "100%",
    maxHeight: "100%",
    width: "auto",
    height: "auto",
    objectFit: "contain",
    display: "block",
    pointerEvents: "none",
  },
  heroTaglineWrap: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.75),
  },
  heroTagline: {
    fontSize: "0.875rem",
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(0.5),
    fontWeight: 700,
    color: "#1A2B4B",
    textAlign: "center",
    lineHeight: 1.3,
  },
  ctaSlot: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(2.5),
  },
  featureBarWrap: {
    flexShrink: 0,
    display: "flex",
    alignItems: "flex-start",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(0.5),
  },
  featureBarImage: {
    width: "100%",
    height: "auto",
    display: "block",
    objectFit: "contain",
  },
  featureBar: {
    display: "flex",
    alignItems: "stretch",
    width: "100%",
    minHeight: LAYOUT.featureBarHeight,
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    boxShadow: "0 4px 24px rgba(15, 23, 42, 0.08)",
    overflow: "hidden",
  },
  featureItem: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    textAlign: "center",
    padding: theme.spacing(1.25, 0.5, 1),
    gap: theme.spacing(0.5),
  },
  featureDivider: {
    width: 1,
    alignSelf: "stretch",
    backgroundColor: "#E8ECF4",
    flexShrink: 0,
  },
  featureIcon: {
    width: 28,
    height: 28,
    objectFit: "contain",
    display: "block",
    // mixBlendMode: "screen",
  },
  featureIconSlot: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    backgroundColor: "#EDE9FE",
    flexShrink: 0,
  },
  featureItemNoIcon: {
    justifyContent: "center",
    paddingTop: theme.spacing(1.25),
    paddingBottom: theme.spacing(1.25),
  },
  featureTitle: {
    fontSize: "0.625rem",
    fontWeight: 700,
    lineHeight: 1.25,
    color: "#1A2B4B",
  },
  featureSubtitle: {
    fontSize: "0.5625rem",
    lineHeight: 1.3,
    color: "#64748B",
    fontWeight: 400,
  },
  featureGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing(0.75),
    width: "100%",
  },
  featureGridCard: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: theme.spacing(1, 1.25),
    boxShadow: "0 2px 12px rgba(15, 23, 42, 0.06)",
    minHeight: 48,
  },
  featureGridIconSlot: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    backgroundColor: "#E8F0FE",
    flexShrink: 0,
  },
  featureGridIcon: {
    width: 28,
    height: 28,
    objectFit: "contain",
    flexShrink: 0,
    // mixBlendMode: "screen",
  },
  featureGridTitle: {
    fontSize: "0.6875rem",
    fontWeight: 700,
    lineHeight: 1.25,
    color: "#1A2B4B",
    textAlign: "left",
  },
  productGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing(0.5),
    width: "100%",
  },
  productCard: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
    padding: theme.spacing(0.5, 0.75),
    boxShadow: "0 2px 12px rgba(15, 23, 42, 0.06)",
    minHeight: 38,
  },
  productBadge: {
    position: "absolute",
    top: 4,
    right: 6,
    fontSize: "0.5rem",
    fontWeight: 700,
    lineHeight: 1,
    padding: "2px 5px",
    borderRadius: 4,
  },
  productBadgeCyan: {
    backgroundColor: "#D6FBF3",
    color: "#00B894",
  },
  productBadgePurple: {
    backgroundColor: "#EDE9FE",
    color: "#6D4BD3",
  },
  productIconSlot: {
    width: 24,
    height: 24,
    borderRadius: 8,
    flexShrink: 0,
  },
  productIcon: {
    width: 24,
    height: 24,
    objectFit: "contain",
    flexShrink: 0,
  },
  productText: {
    minWidth: 0,
    flex: 1,
    paddingRight: theme.spacing(1.5),
  },
  productTitle: {
    fontSize: "0.6875rem",
    fontWeight: 700,
    lineHeight: 1.2,
    color: "#1A2B4B",
  },
  productDescription: {
    fontSize: "0.5625rem",
    lineHeight: 1.2,
    color: "#64748B",
    fontWeight: 400,
    marginTop: 1,
  },
  footer: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "auto",
    backgroundColor: "#F8F9FB",
    paddingTop: theme.spacing(2.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: "calc(16px + var(--safe-area-inset-bottom))",
  },
  dots: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(0.75),
  },
  dot: {
    width: 10,
    height: 10,
    minWidth: 10,
    minHeight: 10,
    padding: 0,
    border: "none",
    borderRadius: "50%",
    backgroundColor: INACTIVE_DOT_COLOR,
    cursor: "pointer",
    transition: "transform 0.2s ease, background-color 0.2s ease",
    "&:focus-visible": {
      outline: `2px solid ${ACCENT_COLOR}`,
      outlineOffset: 2,
    },
  },
  dotActive: {
    backgroundColor: ACCENT_COLOR,
    transform: "scale(1.15)",
  },
  ctaWrap: {
    width: "80%",
    display: "flex",
    justifyContent: "center",
    "& > button": {
      width: "100%",
      maxWidth: 320,
      padding: "12px 28px",
      borderRadius: "50px",
      fontSize: "16px",
      background:
        "linear-gradient(90deg, #2563EB 0%, #093AA4 75%, #002C8D 100%) !important",
    },
  },
}));
